module.exports = __webpack_public_path__ + "img/2.cb5a6fc2.jpg";